<template>
  <div class="mb-5">
    <label for="trackColor" style="font-size: 1.25rem; color: #17A2B8">Choose track color</label>
    <b-form-select
      v-model="selected"
      :options="options"
      value-field="item"
      text-field="name"
      id="trackColor"
    ></b-form-select>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      require: true
    }
  },
  data() {
    return {
      selected: '#E9686B'
    }
  }
}
</script>

<style>

</style>